export default __webpack_public_path__ + "09fefce7eed0ab0632595347c4e0c21c.gif";